//export const baseurl = 'http://192.168.1.158:7878/zttms';
import Vue from 'vue'
import axios from 'axios'
import {baseurl} from '../api/url'
const qs = require('querystring')
var dateFormat = require('dateformat');
var now = new Date();
var timeStamp = dateFormat(now,'yyyymmddHHMM');
var checkV = 'poss' + timeStamp;
// var md5 = require('md5');
const sha256 = require("js-sha256").sha256
// var checkValue = md5(checkV)
var checkValue = sha256(sha256(checkV+'szzt@002197'))
const http = axios.create({
  baseURL: baseurl, // 接口根路径http://192.168.1.158:8080
  // baseURL: 'http://10.11.0.183:8080/zttms/', // 接口根路径
  // 设置超时时间 毫秒
  timeout: 20000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  // 返回数据类型
  responseType: 'json', // default
  // 表明是否有跨域请求
  withCredentials: false,
  transformRequest: [function (data) {
    // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
    // data = qs.stringify(data)
    let options = {
      'condition': {},
      'pageNum': '',
      'numPerPage': '',
      'orderField': '',
      'orderDirection': 'desc',
      'pageFlag': '1',
      'timestamp': timeStamp,
      'checkvalue': checkValue
    }
    // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
    // data = qs.stringify(data)
    if (!data || typeof data === undefined) {
      data = {}
    }
    // 如果是带上传的表单
    if (typeof data.upload !== undefined && data.upload === true) {
      let jsondata = {
        token: 'szzttmsinterface=='
      }
      let formElement = document.getElementById(data.formElement)
      var formData = new FormData(formElement)
      if (typeof data.uploadData !== undefined && typeof data.uploadData === 'object') {
        for (let item in data.uploadData) {
          formData.set(item, data.uploadData[item])
        }
      }
      if (typeof data.areaid !== undefined && data.areaid !== '') {
        formData.append('areaid', data.areaid)
      }
      formData.append('jsondata', JSON.stringify(jsondata))
      return formData
    }
    data.token = 'szzttmsinterface==' // 'kW5YkgncB0mRCpLq9hv6VQ=='
    let nObj
    if (typeof data.write !== undefined && data.write === true) {
      nObj = data
      delete data.write
    } else {
      nObj = Object.assign(options, data)
    }
    let request = {}
    request.jsondata = JSON.stringify(nObj)
    request = qs.stringify(request)
    return request
  }],
  transformResponse: [function (data) {
    // 这里提前处理返回的数据
    //alert(JSON.stringify(data))
    if (typeof data === 'string') { // IE下返回字符串
      return JSON.parse(data)
    }
    return data
  }]

})

const api = {
   /**
   * 多个接口统一查询
   * param data array 需要查询的接口参数数组 内容为单个接口调用时的参数 [{url: 'terminalManagement/terminalModel/queryCon',jsondata:{condition: {'terminal_no': ''},'pageNum': '','numPerPage': '','orderField': '','orderDirection': 'desc','token': '','pageFlag': '1'}}]
   * param self object 调用该方法的组件对像
   * param loading string 数据加载完成后是否要隐藏加载动画
   */
  commonQuery: function (data, self, loading) {
    let api = this
    http.post('/system/index/commonQuery', data).then(function (response) {
      // console.log(response)
      let status = response.data.statusCode
      if (status == '1') { // 失败处理
        //api.getErrorMess(response.data.errorCode)
        console.log("处理失败");
      } else { // 成功后的回调
        self.setData(response.data.data)
        // 隐藏正在加载loading效果
        if (typeof loading !== undefined && loading === false) self.loading = false
      }
    }).catch(function (error) {
      console.log(error)
      // Message.error(error.toString())
    })
  }
}

const ztApi = {
  install: function (Vue, options) {
    Vue.prototype.$ztApi = api
  }
}

export default ztApi



// WEBPACK FOOTER //
// ./src/api/api.js